import { getCompanyId } from '@/utils/getCompanyId';
import store from '@/store'
import {DEFAULT_ENVIRONMENT, NEW_PROFILE_ENVIRONMENT, resolveEnvironmentMap} from '@/shared/productViewer';


interface ProductProfileState {
    product: {
        product_id?: string | number;
        product_profile_id?: string | number;
        sku?: string;
    };
    createSections?: string[];
}

const defaultLightSettings = {
    toneMappingExposure: 1,
    keyLightIntensity: 0.05,
    fillLightIntensity: 0.05,
    engravingTintIntensity: 0.5,
    environmentMap: NEW_PROFILE_ENVIRONMENT,
}

const productProfileMapping = (data: any, state: ProductProfileState): Record<string, any> => {
    const companyId = getCompanyId();

    // Merge profile_type and profile_view into env_param (lights), use defaults if lights not set
    const envParam = {
        ...defaultLightSettings,
        ...data.lights,
        // A Select hands back { label, value }; env_param stores the filename, because the
        // Customizer reads it to load the same map and has no use for the label.
        //
        // An explicit choice always wins. With none, a NEW profile opens on the environment
        // we want new work to use, while an EXISTING one keeps what it has always been lit
        // by — a profile saved for an unrelated reason must not come back looking different.
        environmentMap: data?.lights?.environmentMap
            ? resolveEnvironmentMap(data.lights)
            : (data?.id ? DEFAULT_ENVIRONMENT : NEW_PROFILE_ENVIRONMENT),
        profile_type: data?.profileType?.value || 'laser',
        profile_view: data?.profileView?.value || '3D',
    };

    const is2D = data?.profileView?.value === '2D'

    const isUpdate = !!data.id
    const existingProfiles = data?.product?.product_profiles || []
    const currentProfile = isUpdate ? existingProfiles.find((p: any) => p.id === data.id) : null
    const orderIndex = isUpdate ? currentProfile?.order_index : existingProfiles.length

    return {
        name: data?.name,
        company_id: companyId,
        description: `SKU-${data?.product?.sku}`,
        product_id: data.product.product_id,
        id: data.id || null,
        ...(orderIndex !== undefined ? { order_index: orderIndex } : {}),
        shape_profile_id: store.companySetting?.machine === 'neatolabs' ? (data?.shapeProfile?.value || null) : null,
        view_profile_id: is2D ? null : (data?.viewProfile?.value || null),
        section_ids: state.createSections,

        env_param: envParam,
	    pricing_id: data?.priceModel?.value,


        user_scan_script: "function InterlockHandler(interlockName) Report(\"Interlock triggered. Abort\") controlTcpSocket.Close() System.Abort() end Interlocks.MasterEnable = false Interlocks.Enable(Pin.Din.Interlock1, true) Interlocks.AssertOnCurrentFlow(Pin.Din.Interlock1, true) Interlocks.SetInterlockHandler(InterlockHandler) Interlocks.MasterEnable = true kTCP_DATA_SIZE = 64 kTCP_DATA_TIMEOUT = 1000 kCMD_GET_STATUS = 1 kCMD_MARK_IMAGE = 2 kLASER_TYPE_MARK = 1 kLASER_TYPE_POINTER = 2 kSTATE_UNKNOWN = 0 kSTATE_NOT_READY = 1 kSTATE_IDLE = 2 kSTATE_WAITING_TO_START = 3 kSTATE_MARKING = 4 function NetworkErrorFunction(message, error) Report(\"Network Error\"..message) end function ImageIndexFromName(imageName) for key,value in pairs(Images) do if (key == imageName) then return value end end end function MarkImage(imageName, markType) if not (markType == kLASER_TYPE_MARK) then imageName = imageName..\"_Preview\" end local ImageIndex = ImageIndexFromName(imageName) if not (ImageIndex == nil) then IO.WriteDigital(Pin.Dout.MarkInProgress,1,true); if (markType == kLASER_TYPE_MARK) then Laser.PointerDisable() else Laser.PointerEnable() end System.Flush() ScanImage(ImageIndex) Laser.WaitForEnd() Report(imageName..\" finished marking\") IO.WriteDigital(Pin.Dout.MarkInProgress,0,true); return true else Report(imageName..\" is an invalid image.\") return false end end System.EnableZCompensation() state = kSTATE_UNKNOWN keep_running = 1 controlTcpSocket = Network.OpenTcpSocket(\"0.0.0.0\", 5033, true, NetworkErrorFunction) while(keep_running) do data = controlTcpSocket.Receive(kTCP_DATA_SIZE,kTCP_DATA_TIMEOUT,NetworkErrorFunction) if(data.Length() > 0) then if(data[1] == kCMD_GET_STATUS) then controlTcpSocket.Send(state, NetworkErrorFunction) elseif(data[1] == kCMD_MARK_IMAGE) then local markType = data[2] data.Remove(1) data.Remove(1) MarkImage(data.GetString(Encoding.UTF8), markType) end end end controlTcpSocket.Close()".replace(/[\t\n\r]/g, ' '),
        segmentation_length: 1.0,
        lumia_lase_script: "EMPTY",
        parameters: '{"version":1}',
    };
};

export default productProfileMapping;